<template>
	<v-layout row wrap>
		<v-flex class="mb-4" xs12 >
			<h1 class="title mb-2">Upload Payslip</h1>
			<div style="min-height:400px;">
				<div class="text-xs-center">
					<v-dialog v-model="dialog" persistent max-width="800px">
						<template v-slot:activator="{ on }">
							<v-btn color="blue-grey" class="white--text" :loading="loading2" :disabled="loading2" @click="loader = 'loading2'" v-on="on">
								Upload Payslip
								<v-icon right dark>fas fa-cloud-upload-alt</v-icon>
							</v-btn>
						</template>
						<v-card>
							<v-card-title>
								<span class="headline">Payroll File</span>
							</v-card-title>
							<v-card-text>
								<div style="width:100%;text-align:center">
									<p>Please select a CSV file to upload.</p>
									<input type="file" id="csv_file" name="csv_file" class="form-control" @change="loadCSV($event)">
								</div>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
					<v-btn color="red darken-1" class="white--text" :loading="loading3" :disabled="loading3" @click="downloadAUBTemplate">
						Download AUB Template File
						<v-icon right dark>fas fa-cloud-download-alt</v-icon>
					</v-btn>
					<v-btn color="orange darken-1" class="white--text" :loading="loading3" :disabled="loading3" @click="downloadUBTemplate">
						Download UB Template File
						<v-icon right dark>fas fa-cloud-download-alt</v-icon>
					</v-btn>
					<v-card :hidden="vcard" style="margin-top:10px">
						<v-card-title>
							<v-layout wrap>
									<v-flex xs2 style="margin-right:10px">
										<v-menu lazy :close-on-content-click="false" v-model="datemenu1" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px">
								          <v-text-field
								            slot="activator"
								            label="Payroll Period Start"
								            v-model="date1"
								            prepend-icon="fa-calendar"
								            readonly
								          ></v-text-field>
								          <v-date-picker v-model="date1" no-title scrollable actions></v-date-picker>
								        </v-menu>
									</v-flex>

									<v-flex xs2 style="margin-right:10px">
										<v-menu lazy :close-on-content-click="false" v-model="datemenu2" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px">
								          <v-text-field
								            slot="activator"
								            label="Payroll Period End"
								            v-model="date2"
								            prepend-icon="fa-calendar"
								            readonly
								          ></v-text-field>
								          <v-date-picker v-model="date2" no-title scrollable actions></v-date-picker>
								        </v-menu>
									</v-flex>

									<v-flex xs2>
										<v-menu lazy :close-on-content-click="false" v-model="datemenu3" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px">
								          <v-text-field
								            slot="activator"
								            label="Pay Date"
								            v-model="paydate"
								            prepend-icon="fa-calendar"
								            readonly
								          ></v-text-field>
								          <v-date-picker v-model="paydate" no-title scrollable actions></v-date-picker>
								        </v-menu>
									</v-flex>
							</v-layout>
							<v-spacer></v-spacer>
							<template v-if="parse_csv">
								<v-btn color="blue-grey" class="white--text" @click="submitFile()">SUBMIT</v-btn>
							</template>
						</v-card-title>
						<v-card-text style="overflow: auto">
							<v-layout>
								<v-flex xs3 style="border: 1px solid lightgray">
									<b>Total Gross Pay:</b> {{ totalGrossPay }}
								</v-flex>
							</v-layout>
							<v-layout>
								<v-flex xs3 style="border: 1px solid lightgray">
									<b>Total Net Pay:</b> {{ totalNetPay }}
								</v-flex>
							</v-layout>
							<table>
								<thead>
									<tr>
										<th class="blue dark-3" v-for="key in parse_header" @click="sortBy(key)" :class="{ active: sortKey == key }">
											{{ key | capitalize }}
											<span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
											</span>
										</th>
									</tr>
								</thead>
								<tr v-for="csv in parse_csv">
									<td v-for="key in parse_header">
										{{ csv[key] }}
									</td>
								</tr>
							</table>
						</v-card-text>
					</v-card>
				</div>
			</div>
		</v-flex>
	</v-layout>
</template>
<script>
	import Vue from 'vue';
	import VueCookies from 'vue-cookies'
	import axios from 'axios'
	import moment from 'moment'
	import VueSwal from 'vue-swal'
    Vue.use(VueSwal)

	export default {
		mounted: function(){
			this.token = VueCookies.get(this.cookieKey).token;
		},
		watch: {
			loader () {
				const l = this.loader
				this[l] = !this[l]

				setTimeout(() => (this[l] = false), 3000)
				this.loader = null
			}
		},
		data: () => ({
			loader: null,
			loading2: false,
			loading3: false,
			dialog: false,
			vcard: true,
			date1: moment().format("Y-MM-DD"),
			date2: moment().add(14,'days').format("Y-MM-DD"),
			paydate: moment().format("Y-MM-DD"),
			datemenu1: false,
			datemenu2: false,
			datemenu3: false,
			url1:'payrollTemplate.csv',
			url2:'payrollTemplateUB.csv',

			channel_name: '',
			channel_fields: [],
			channel_entries: [],
			parse_header: [],
			parse_csv: [],
			sortOrders:{},
			sortKey: '',
			csvdata: []
		}),
		
		filters: {
		    capitalize: function (str) {
		      return str.charAt(0).toUpperCase() + str.slice(1)
		    }
		},
		computed: {
			totalGrossPay: function (){
				let totalGross = [];
				this.parse_csv.forEach(e =>{
					totalGross.push(parseFloat(e.gross_pay));
				});
				return totalGross.reduce(function(total, num){ return total + num}, 0);
			},
			totalNetPay: function (){
				let totalNet = [];
				this.parse_csv.forEach(e =>{
					totalNet.push(parseFloat(e.net_pay));
				});
				return totalNet.reduce(function(total, num){ return total + num}, 0);
			},
		},
		methods: {
			downloadAUBTemplate(){
				axios({
					method: 'get',
					url: this.url1,
					responseType: 'blob'
				})
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'AUB Template File.csv'); //or any other extension
					document.body.appendChild(link);
					link.click();
				});
			},
			downloadUBTemplate(){
				axios({
					method: 'get',
					url: this.url2,
					responseType: 'blob'
				})
				.then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', 'UB Template File.csv'); //or any other extension
					document.body.appendChild(link);
					link.click();
				});
			},
			sortBy: function (key) {
				var vm = this
				vm.sortKey = key
				vm.sortOrders[key] = vm.sortOrders[key] * -1
			},
			csvJSON(csv){
				var vm = this
				var lines = csv.split("\r")
				var result = []
				var headers = lines[0].split(",")
				vm.parse_header = lines[0].split(",")

				lines[0].split(",").forEach(function (key) {
					vm.sortOrders[key] = 1
				})

				lines.map(function(line, indexLine){
					if (indexLine < 1) return // Jump header line

					var obj = {}
					var currentline = line.split(",")

					headers.map(function(header, indexHeader){
						obj[header] = currentline[indexHeader]
					})

					result.push(obj)
				})
				this.dialog = false;
				this.vcard = false;
				result.pop() // remove the last item because undefined values

				return result // JavaScript object
			},
			loadCSV(e) {
				var vm = this
				if (window.FileReader) {
					var reader = new FileReader();
					reader.readAsText(e.target.files[0]);
					// Handle errors load
					reader.onload = function(event) {
						var csv = event.target.result;
						vm.parse_csv = vm.csvJSON(csv)
						vm.csvdata = csv
					};
					reader.onerror = function(evt) {
						if(evt.target.error.name == "NotReadableError") {
							_this.$swal("Error", "Cannot read file!", "danger")
						}
					};
				} else {
					_this.$swal("Error", "FileReader are not supported in this browser!", "danger")
				}
			},
			submitFile() {
				let _this = this,
				formData = new FormData();
				_this.eventHub.$emit("openGlobalLoaderModal");

				formData.append('header', this.parse_header);
				formData.append('csvdata', JSON.stringify(this.parse_csv).replace(/\\n|\\r/g, ''));
                formData.append('datefrom', this.date1);
                formData.append('dateto', this.date2);
                formData.append('paydate', this.paydate);
                
	           	axios.create({
	                baseURL : _this.apiUrl,
	                headers : {
	                    'Authorization' : `Bearer ${this.token}`
	                }
	            })
	            .post('/payslip/upload', formData)
	            .then(function(res){
	            	_this.eventHub.$emit("closeGlobalLoaderModal");
	                _this.$swal("Success", "Payslip data has been uploaded.", "success")
	            });
			}
		}
	}
</script>

<style scoped>
table {
	font-family: arial, sans-serif;
	border-collapse: collapse;
	width: 100%;
}
th{
	padding-top: 12px;
  	padding-bottom: 12px;
  	text-align: left;
  	color: white;
}
td, th{
	border: 1px solid #ddd;
	text-align: left;
	padding: 8px;
}

tr:nth-child(even) {
	background-color: #f2f2f2;
}
.text-right {
	text-align: right;
}
.custom-loader {
	animation: loader 1s infinite;
	display: flex;
}
@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@-o-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
@keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>